import React, { memo } from 'react'
import { Group, Stack, Text } from '@mantine/core'
import { ReactComponent as LeaguestarLogo } from '../../../assets/leaguestar_logo_white.svg'
import classes from './Footer.module.css'
import Version from '../version/version'

const Footer = memo(() => {
  return (
    <footer className={classes.footer}>
      <Stack>
        <Text className={classes.link}>
          <a
            className={classes.link}
            href="/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          {' and '}
          <a
            className={classes.link}
            href="/terms-of-service/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          {' apply.'}
        </Text>
        <Group justify="center" align="center" gap="xxxs">
          <LeaguestarLogo className={classes.icon} />
          <Version component="footer" />
        </Group>
      </Stack>
    </footer>
  )
})

export default Footer
